import soccerImage from "app/images/upgrade-success-soccer.jpg";
import golfersOne from "app/images/upgrade-success-golfers-one.png";
import golfersTwo from "app/images/upgrade-success-golfers-two.png";

export const getSportImage = (sport?: string): string => {
  const normalizedSport = sport?.toLowerCase();

  if (normalizedSport === "golf") {
    const golfImages = [golfersOne, golfersTwo];
    const randomIndex = Math.floor(Math.random() * golfImages.length);
    return golfImages[randomIndex];
  }

  return soccerImage;
};
